/**
 * Hook for the admin feedback-analytics panel.
 *
 * @module useFeedbackAnalytics
 */

import { useQuery } from '@tanstack/react-query';
import {
  getFeedbackAnalytics,
  type FeedbackAnalytics,
  type FeedbackAnalyticsFilters,
} from '@/lib/feedbackAnalyticsApi';

export const FEEDBACK_ANALYTICS_QUERY_KEY = ['feedbackAnalytics'] as const;

export function useFeedbackAnalytics(
  filters: FeedbackAnalyticsFilters = {},
  enabled: boolean = true,
) {
  const { data, isLoading, isError, refetch } = useQuery<FeedbackAnalytics | null>({
    queryKey: [...FEEDBACK_ANALYTICS_QUERY_KEY, filters],
    queryFn: () => getFeedbackAnalytics(filters),
    enabled,
  });
  return { analytics: data ?? null, isLoading, isError, refetch };
}
